import axios from "axios";

import config from "../config/config";
import { getToken } from "../common";

export const generateAPIKeyAPI = async ({ name }) => {
  const payload = {
    name,
  };

  return await axios({
    method: "post",
    url: `${config.api.base_url}api-keys/`,
    data: payload,
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: getToken(),
    },
  });
};

export default generateAPIKeyAPI;
